/* istanbul ignore file */
import { createAction, createReducer } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  todosAssuntos: [],

  inputSelectOptionsCargo: [],
  inputSelectOptionsSituacao: [],
  inputSelectOptionsSetores: [],
  inputSelectAtendentes: [], // TODO: USAR

  inputDadosRequerimentoCompleto: {},
  inputDadosCadastrais: null,
  inputSelectOptionsServicos: [],
  inputSelectOptionsSexo: [],
  inputSelectOptionsEscolaridade: [],
  inputSelectOptionsProfissao: [],
  inputSelectOptionsAreaAtuacao: [],
  inputSelectOptionsInstituicao: [],

  inputSelectOptionsSolicitacoes: [], // TODO: REPETIDO
};
export const duckInputTodosAssuntos = createAction('DUCK_TODOS_ASSUNTOS');

export const duckInputSelectOptionsCargo = createAction('DUCK_INPUT_SELECT_OPTIONS_CARGO');
export const duckInputSelectOptionsSituacao = createAction('DUCK_INPUT_SELECT_OPTIONS_SITUACAO');
export const duckInputSelectOptionsSetores = createAction('DUCK_INPUT_SELECT_OPTIONS_SETORES');
export const duckInputSelectOptionsAtendentes = createAction('DUCK_INPUT_SELECT_OPTIONS_ATENDENTES');

export const duckInputRequerimentoCompleto = createAction('DUCK_INPUT_TODOS_DADOS_REQUERIMENTO');
export const duckInputDadosCadastrais = createAction('DUCK_INPUT_DADOS_CADASTRAIS');
export const duckInputSelectOptionsServico = createAction('DUCK_INPUT_SELECT_OPTIONS_SERVICO');
export const duckInputSelectOptionsSexo = createAction('DUCK_INPUT_SELECT_OPTIONS_SEXO');
export const duckInputSelectOptionsEscolaridade = createAction('DUCK_INPUT_SELECT_OPTIONS_ESCOLARIDADE');
export const duckInputSelectOptionsProfissao = createAction('DUCK_INPUT_SELECT_OPTIONS_PROFISSAO');
export const duckInputSelectOptionsAreaAtuacao = createAction('DUCK_INPUT_SELECT_OPTIONS_AREA_ATUACAO');
export const duckInputSelectOptionsInstituicao = createAction('DUCK_INPUT_SELECT_OPTIONS_INSTITUICAO');

export const duckInputSelectOptionsServicos = createAction('DUCK_INPUT_SELECT_OPTIONS_SOLICITACOES');

export default createReducer(INITIAL_STATE, {
  [duckInputTodosAssuntos.type]: (state, action) => ({
    ...state,
    todosAssuntos: action.payload,
  }),
  [duckInputSelectOptionsSituacao.type]: (state, action) => ({
    ...state,
    inputSelectOptionsSituacao: action.payload,
  }),
  [duckInputSelectOptionsCargo.type]: (state, action) => ({
    ...state,
    inputSelectOptionsCargo: action.payload,
  }),
  [duckInputSelectOptionsSetores.type]: (state, action) => ({
    ...state,
    inputSelectOptionsSetores: action.payload,
  }),
  [duckInputSelectOptionsAtendentes.type]: (state, action) => ({
    ...state,
    inputSelectAtendentes: action.payload,
  }),
  [duckInputRequerimentoCompleto.type]: (state, action) => ({
    ...state,
    inputDadosRequerimentoCompleto: action.payload,
  }),
  [duckInputDadosCadastrais.type]: (state, action) => ({
    ...state,
    inputDadosCadastrais: action.payload,
  }),
  [duckInputSelectOptionsServico.type]: (state, action) => ({
    ...state,
    inputSelectOptionsServicos: action.payload,
  }),
  [duckInputSelectOptionsSexo.type]: (state, action) => ({
    ...state,
    inputSelectOptionsSexo: action.payload,
  }),
  [duckInputSelectOptionsEscolaridade.type]: (state, action) => ({
    ...state,
    inputSelectOptionsEscolaridade: action.payload,
  }),
  [duckInputSelectOptionsProfissao.type]: (state, action) => ({
    ...state,
    inputSelectOptionsProfissao: action.payload,
  }),
  [duckInputSelectOptionsAreaAtuacao.type]: (state, action) => ({
    ...state,
    inputSelectOptionsAreaAtuacao: action.payload,
  }),
  [duckInputSelectOptionsInstituicao.type]: (state, action) => ({
    ...state,
    inputSelectOptionsInstituicao: action.payload,
  }),
  [duckInputSelectOptionsServicos.type]: (state, action) => ({
    ...state,
    inputSelectOptionsSolicitacoes: action.payload,
  }),
});
